angular.module('lwNamb').controller('styleSpecsCtrl', ['$scope', function($scope) {}]);
